import { basePath } from '../basePath';

export const loadTxt = async (filePath: string) => {
  if (filePath) {
    try {
      // Dynamically import the file with the specified extension
      const response = await fetch(
        `/${basePath}/code-snippets/${filePath}.txt`
      );
      return await response.text();
    } catch (error) {
      console.error(`Error loading ${filePath}:`, error);
    }
  }
  return null;
};
